module.exports = __webpack_public_path__ + "static/artist-management-case-study-3a81642585d6661928647ad85d0a1d0b.png";